import { getPreferredPhone, useGetAllContacts } from "@api/contactService";
import { useEffect, useState } from "react";
import Box from '@mui/joy/Box';
import IconButton from '@mui/joy/IconButton';
import Tooltip from '@mui/joy/Tooltip';
import Typography from '@mui/joy/Typography';
import ObjectIndex from "@components/objects/ObjectIndex";
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import ObjectInlineEdit from "@components/objects/ObjectInlineEdit";
import { useCreatePublicImprovement, useDeletePublicImprovement, useGetAllPublicImprovements, useUpdatePublicImprovement } from "@api/publicImprovementService";
import { formatCurrency } from "@utils/numbers";
import { formatDate } from "@utils/dates";
import { useCreateMembeshipLevel, useDeleteMembeshipLevel, useGetAllMembeshipLevels, useUpdateMembeshipLevel } from "@api/membershipLevelService";
import { useCreateTraining, useDeleteTraining, useGetAllTrainings, useUpdateTraining } from "@api/trainingService";
import { useCreateAppeal, useDeleteAppeal, useGetAllAppeals, useUpdateAppeal } from "@api/appealService";
import { useCreateCampaign, useDeleteCampaign, useGetAllCampaigns, useUpdateCampaign } from "@api/campaignService";
import { useCreatePark, useDeletePark, useGetAllParks, useUpdatePark } from "@api/parksService";
import { MapModal } from "@components/MapModal";

const columns = [
    {
        id: 'name',
        numeric: false,
        disablePadding: true,
        sortable: true,
        label: 'Name',
        type: 'text',
        placeholder: 'e.g. Washington Park',
        config: {
            required: true,
        },
        cell: (row, {LinkComponent}) => {
            // const LinkComponent = view === 'deleted' ? Box : Link;
            return (<>
                <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>{row.name}</Typography>
            </>)
        }
      },
      {
        id: 'location',
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: 'Location',
        type: 'text',
        placeholder: 'e.g. 42nd & Maine Street',
        cell: (row) => row.location,
      },
      {
        id: 'latitude',
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: 'Coordinates',
        type: 'text',
        placeholder: 'Latitude',
        cell: (row) => {
            if(!row.latitude || !row.longitude) {
                return null;
            }

            return (<>
                {row.latitude}, {row.longitude}
                <br/>
                <MapModal position={{lat: row.latitude, lng: row.longitude}}/>
            </>);
        },
        additionalEditFields: [
            {
                id: 'longitude',
                placeholder: 'Longitude',
                type: 'text',
                // tooltip: 'If private and public dollars were used, use two entries',
            }
        ],
      },
      {
        id: 'amenities',
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: 'Amenities',
        type: 'textarea',
        cell: (row) => row.amenities,
      },
];

const listCell = (row, {LinkComponent}) => {
    return (<>
    {row.name !== row.company_name && (
        <Box sx={{mb: 1}}>
            <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>
                <LinkComponent to={`/contacts/${row.id}`} object={row}>
                    {row.name}
                </LinkComponent>
            </Typography>
            {row.company_name && (<Typography fontSize="sm">{row.company_name}</Typography>)}
        </Box>
    )}
    {row.name === row.company_name && (
        <Box sx={{mb: 1}}>
            <Typography>
                <LinkComponent to={`/contacts/${row.id}`} object={row}>
                    {row.company_name}
                </LinkComponent>
            </Typography>
        </Box>
        )}
    </>);
};

const listActions = (row, {view, LinkComponent, ViewAction}) => {
    if(view === 'deleted') {
        return null;
    }

    return (<>
        <Tooltip title="Email">
            <IconButton
                size="sm"
                color="neutral"
                variant="outlined"
                sx={{ bgcolor: 'background.surface', ":disabled": {opacity: 0.3} }}
                disabled={!row.email}
                component={'a'}
                href={`mailto:${row.email}`}
                >
                <EmailRoundedIcon />
            </IconButton>
        </Tooltip>
        <Tooltip title="Call">
            <IconButton
                size="sm"
                color="neutral"
                variant="outlined"
                sx={{ bgcolor: 'background.surface', ":disabled": {opacity: 0.3} }}
                disabled={!getPreferredPhone(row)}
                component={'a'}
                href={`tel:${getPreferredPhone(row)}`}
                >
                <LocalPhoneRoundedIcon />
            </IconButton>
        </Tooltip>
    </>);
};

export default function Parks() {
    return (
        <ObjectInlineEdit
            query={useGetAllParks}
            createMutation={useCreatePark}
            updateMutation={useUpdatePark}
            deleteMutation={useDeletePark}

            type={'park'}
            endpoint={'parks'}
            permissionType={'settings'}
            title={'Parks'}
            color={'default'}
            columns={columns}
            listCell={listCell}
            listActions={listActions}
        />
    )
}
